import {Controller} from "stimulus"
import $ from 'jquery';
import {add_direct_product_to_cart, create_array_for_product, create_shopping_cart} from "./b2b_controller";
import {unBlockElementById} from "./blockUI_controller";
import bootbox from "bootbox";
import {validate} from "./validate_controller";
import {location_make_comment, pick_up_location_info} from "./preferences_controller";
import {showMapModal} from "../utils/map_modal";
import flatpickr from "flatpickr";
import {setSessionVar} from "./sessionStorage_controller";

let date_disabled = [];
let flatpick_lang;

export default class extends Controller {
    static targets = ["productType"];

    connect() {
        const campos_reserva = $(`#campos_reserva`);
        if (campos_reserva[0] !== undefined) {
            /* Para campos de la página de Buggy */
            if (campos_reserva[0].dataset.product_tipo === 'buggy') {
                let buggy_date_page;
                buggy_date_page = $('#buggy_date_page');

                flatpickr(buggy_date_page, {
                    altInput: true,
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    disable: date_disabled,
                    minDate: new Date().fp_incr(parseInt(campos_reserva[0].dataset.reservation_time)),
                    maxDate: new Date().fp_incr(90),
                    locale: 'es'
                });

                buggy_date_page.on('change', function (e) {
                    /* SETEANDO FECHA EN QUE EMPIEZA Y TERMINA LA EXCURSION */
                    setSessionVar('from_date', e.target.value, 'add', true, false).then(
                        from => {
                            create_array_for_product('from_date', from.value);
                        }
                    );
                    setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(
                        to => {
                            create_array_for_product('to_date', to.value);
                        }
                    );
                })
            }

            /* Para campos de la página de Turismo Accesible (CubaTram) */
            if (campos_reserva[0].dataset.product_tipo === 'accessible_tourism') {
                let accessible_tourism_pick_up_location_page, accessible_tpul_btn, accessible_tourism_date_page, accessible_tourism_observaciones_page,
                    pick_up_location_name, pick_up_location_latitude, pick_up_location_longitude, pick_up_location_description;
                accessible_tourism_pick_up_location_page = $('#accessible_tourism_pick_up_location_page');
                accessible_tpul_btn = $('#accessible_tpul_btn');
                accessible_tourism_date_page = $('#accessible_tourism_date_page');
                accessible_tourism_observaciones_page = $('#accessible_tourism_observaciones_page');

                accessible_tourism_pick_up_location_page.prop('disabled', false).select2({
                    theme: "bootstrap",
                    placeholder: I18n.t('global.main.form.select_pick_up_location'),
                    dropdownParent: '#campos_accessible_tourism',
                    ajax: {
                        url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities/pick_up_location`,
                        dataType: "json",
                        language: "es",
                        data: function (params) {
                            return {
                                search: params.term,
                                modality: campos_reserva[0].dataset.modality_id
                            }
                        },
                        type: 'GET',
                        processResults: function (data, params) {
                            let result = [];
                            /*params.page = params.page || 1;*/
                            data.rows.map((elem, key) => {
                                result.push({
                                    id: elem,
                                    text: elem
                                })
                            })
                            return {
                                results: result
                            }
                        }
                    }
                }).on('change', function (e) {
                    let pick_up_location_selected;
                    pick_up_location_selected = e.target.value;

                    location_make_comment(accessible_tourism_observaciones_page, "Punto de Recogida", accessible_tourism_pick_up_location_page);

                    pick_up_location_info(pick_up_location_selected).then(
                        pick_up_location => {
                            if (pick_up_location.success) {
                                pick_up_location_name = pick_up_location.data.name;
                                pick_up_location_latitude = pick_up_location.data.latitude;
                                pick_up_location_longitude = pick_up_location.data.longitude;
                                pick_up_location_description = pick_up_location.data.description;

                                if (pick_up_location_latitude !== '' && pick_up_location_longitude !== '') {
                                    accessible_tpul_btn[0].classList.remove('ocultar');
                                } else {
                                    accessible_tpul_btn[0].classList.add('ocultar');
                                }
                            }
                        }
                    )
                })

                accessible_tpul_btn.on('click', function (e) {
                    showMapModal(pick_up_location_latitude, pick_up_location_longitude, {
                        title: 'Ubicación del punto de recogida',
                        markerText: pick_up_location_name,
                        description: pick_up_location_description
                    }).then(r => {
                    });
                })

                flatpickr(accessible_tourism_date_page, {
                    altInput: true,
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    disable: date_disabled,
                    minDate: new Date().fp_incr(parseInt(campos_reserva[0].dataset.reservation_time)),
                    maxDate: new Date().fp_incr(90),
                    locale: 'es'
                });

                accessible_tourism_date_page.on('change', function (e) {
                    /* SETEANDO FECHA EN QUE EMPIEZA Y TERMINA LA EXCURSION */
                    setSessionVar('from_date', e.target.value, 'add', true, false).then(
                        from => {
                            create_array_for_product('from_date', from.value);
                        }
                    );
                    setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(
                        to => {
                            create_array_for_product('to_date', to.value);
                        }
                    );
                })
            }

            /* Para campos de la página de Traslados (Transfer) */
            if (campos_reserva[0].dataset.product_tipo === 'transfers') {
                let transfers_pul_btn_page, transfers_pick_up_location_page, transfers_dol_btn_page, transfers_drop_off_location_page,
                    transfers_date_page, transfers_observaciones_page,
                    pick_up_location_name, pick_up_location_latitude, pick_up_location_longitude, pick_up_location_description,
                    drop_off_location_name, drop_off_location_latitude, drop_off_location_longitude, drop_off_location_description;
                transfers_pul_btn_page = $('#transfers_pul_btn_page');
                transfers_pick_up_location_page = $('#transfers_pick_up_location_page');
                transfers_dol_btn_page = $('#transfers_dol_btn_page');
                transfers_drop_off_location_page = $('#transfers_drop_off_location_page');
                transfers_observaciones_page = $('#transfers_observaciones_page');
                transfers_date_page = $('#transfers_date_page');

                transfers_drop_off_location_page.prop('disabled', true).select2({
                    theme: 'bootstrap',
                    placeholder: I18n.t('global.main.form.select_drop_off_location')
                });

                transfers_drop_off_location_page.empty().prop('disabled', true);

                flatpickr(transfers_date_page, {
                    altInput: true,
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    disable: date_disabled,
                    minDate: new Date().fp_incr(parseInt(campos_reserva[0].dataset.reservation_time)),
                    maxDate: new Date().fp_incr(90),
                    locale: 'es'
                });

                transfers_date_page.on('change', function (e) {
                    /* SETEANDO FECHA EN QUE EMPIEZA Y TERMINA LA EXCURSION */
                    setSessionVar('from_date', e.target.value, 'add', true, false).then(
                        from => {
                            create_array_for_product('from_date', from.value);
                        }
                    );
                    setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(
                        to => {
                            create_array_for_product('to_date', to.value);
                        }
                    );
                })

                transfers_pick_up_location_page.prop('disabled', false).select2({
                    theme: "bootstrap",
                    placeholder: I18n.t('global.main.form.select_pick_up_location'),
                    dropdownParent: '#campos_transfers',
                    ajax: {
                        url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities/pick_up_location`,
                        dataType: "json",
                        language: "es",
                        data: function (params) {
                            /*let point_exc = '';
                            if (transfers_drop_off_location[0].selectedOptions.length !== 0) {
                                point_exc = transfers_drop_off_location[0].selectedOptions[0].value;
                            }*/

                            return {
                                search: params.term,
                                modality: campos_reserva[0].dataset.modality_id
                            }
                        },
                        type: 'GET',
                        processResults: function (data, params) {
                            let result = [];
                            /*params.page = params.page || 1;*/
                            data.rows.map((elem, key) => {
                                result.push({
                                    id: elem,
                                    text: elem
                                })
                            })
                            return {
                                results: result
                            }
                        }
                    }
                }).on('change', function (e) {
                    let pick_up_location_selected;
                    pick_up_location_selected = e.target.value;
                    transfers_drop_off_location_page.empty();
                    transfers_observaciones_page.prop('disabled', false);
                    /*transfers_observaciones[0].value = '';*/
                    location_make_comment(transfers_observaciones_page, "Punto de Recogida", transfers_pick_up_location_page, "Punto de Destino", transfers_drop_off_location_page);

                    pick_up_location_info(pick_up_location_selected).then(
                        pick_up_location => {
                            if (pick_up_location.success) {
                                pick_up_location_name = pick_up_location.data.name;
                                pick_up_location_latitude = pick_up_location.data.latitude;
                                pick_up_location_longitude = pick_up_location.data.longitude;
                                pick_up_location_description = pick_up_location.data.description;

                                if (pick_up_location_latitude !== '' && pick_up_location_longitude !== '') {
                                    transfers_pul_btn_page[0].classList.remove('ocultar');
                                } else {
                                    transfers_pul_btn_page[0].classList.add('ocultar');
                                }
                            }
                        }
                    )

                    transfers_drop_off_location_page.prop('disabled', false).select2({
                        theme: "bootstrap",
                        placeholder: I18n.t('global.main.form.select_drop_off_location'),
                        dropdownParent: '#campos_transfers',
                        ajax: {
                            url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities/drop_off_location`,
                            dataType: "json",
                            language: "es",
                            data: function (params) {
                                let point_exc = '';
                                if (transfers_pick_up_location_page[0].selectedOptions.length !== 0) {
                                    point_exc = transfers_pick_up_location_page[0].selectedOptions[0].value;
                                }

                                return {
                                    search: params.term,
                                    modality: campos_reserva[0].dataset.modality_id,
                                    point_exc: point_exc
                                }
                            },
                            type: 'GET',
                            processResults: function (data, params) {
                                let result = [];
                                /*params.page = params.page || 1;*/
                                data.rows.map((elem, key) => {
                                    result.push({
                                        id: elem,
                                        text: elem
                                    })
                                })
                                return {
                                    results: result
                                }
                            }
                        }
                    }).on('change', function (e) {
                        let drop_off_location_selected;
                        drop_off_location_selected = e.target.value;
                        transfers_observaciones_page.prop('disabled', false);
                        /*transfers_observaciones[0].value = '';*/
                        location_make_comment(transfers_observaciones_page, "Punto de Recogida", transfers_pick_up_location_page, "Punto de Destino", transfers_drop_off_location_page);

                        pick_up_location_info(drop_off_location_selected).then(
                            drop_off_location => {
                                if (drop_off_location.success) {
                                    drop_off_location_name = drop_off_location.data.name;
                                    drop_off_location_latitude = drop_off_location.data.latitude;
                                    drop_off_location_longitude = drop_off_location.data.longitude;
                                    drop_off_location_description = drop_off_location.data.description;

                                    if (drop_off_location_latitude !== '' && drop_off_location_longitude !== '') {
                                        transfers_dol_btn_page[0].classList.remove('ocultar');
                                    } else {
                                        transfers_dol_btn_page[0].classList.add('ocultar');
                                    }
                                }
                            }
                        )
                    })
                })
            }

            /* Para campos de la página de Bicicleta */
            if (campos_reserva[0].dataset.product_tipo === 'bicicleta') {
                let bicicleta_date;
                bicicleta_date = $('#bicicleta_date');

                flatpickr(bicicleta_date, {
                    altInput: true,
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    disable: date_disabled,
                    minDate: new Date().fp_incr(parseInt(campos_reserva[0].dataset.reservation_time)),
                    maxDate: new Date().fp_incr(90),
                    locale: 'es'
                });

                bicicleta_date.on('change', function (e) {
                    /* SETEANDO FECHA EN QUE EMPIEZA Y TERMINA LA EXCURSION */
                    setSessionVar('from_date', e.target.value, 'add', true, false).then(
                        from => {
                            create_array_for_product('from_date', from.value);
                        }
                    );
                    setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(
                        to => {
                            create_array_for_product('to_date', to.value);
                        }
                    );
                })
            } else if (campos_reserva[0].dataset.product_tipo === 'bike') {
                console.info('aki en bike');
            }
        }
    }

    page(e) {
        let page_e = e;
        /*console.info(page_e.target.dataset.product_tipo);*/

        if (page_e.target.dataset.product_tipo === 'safari') {
            bootbox.dialog({
                title: 'Campos requeridos',
                message: `<div id="campos_reserva" class="col-12 row" data-controller="preferences datime">
                        <div class="form-group col-12">
                          <label for="safari_date_group" data-preferences-target="dateCollect"></label>
                          <input id="safari_date_group" type="text" class="form-control required">
                          <span class="helper-text small"></span>
                        </div>
                        <!-- EXCURSION UBICACION -->
                        <div id="excursion_location_container" class="form-group col-12">
                          <label for="excursion_location"> ${I18n.t('reservation.side_bar.pickup_place')}</label>
                          <input id="excursion_location" type="text" class="form-control required" placeholder="${I18n.t('reservation.side_bar.pickup_place')}" data-action="preferences#make_comment" data-text="Ubicación: ">
                          <span class="helper-text small text-muted">${I18n.t('reservation.side_bar.pickup_place_description')}</span>
                        </div>
                        <!-- EXCURSION IDIOMA -->
                        <div id="excursion_lang_container" class="form-group col-12">
                          <label for="excursion_lang"> ${I18n.t('reservation.side_bar.lang')}</label>
                          <select id="excursion_lang" class="form-control required"></select>
                          <span class="helper-text small"></span>
                        </div>
                      </div>`,
                size: 'extra-large',
                buttons: {
                    cancel: {
                        label: "Cancelar",
                        className: 'btn-secondary'
                    },
                    ok: {
                        label: "Aceptar",
                        className: 'btn-success',
                        callback: function (e) {
                            /*let check = $('#terms_and_condition_accepted');
                            if (check.is(':checked')) {
                                resolve({
                                    success: true
                                })
                            } else {
                                toastr.warning('Debe acceptar nuestros terminos y condiciones para continuar', 'Términos y condiciones');
                                return true;
                            }*/
                            /*validate('campos_reserva').then(r => {
                                console.info(r);
                                console.info(page_e.target.dataset.product_id); // product_id
                            })*/
                            // Llamada a la función validate

                            // Desactivar el cierre automático del cuadro de diálogo
                            return false;
                        }
                    }
                },
                onShown: function () {
                    // Agregar un evento personalizado al botón "Aceptar"
                    $('.bootbox-accept').on('click', function () {
                        validate('campos_reserva').then(r => {
                            if (r.next === false) {
                                // Validación fallida: mostrar advertencia y mantener el cuadro de diálogo abierto
                                toastr.warning('Por favor, complete los campos requeridos para continuar.', 'Campos requeridos');
                            } else {
                                let product_id = e.target.dataset.product_id; // product_id
                                let product_type = e.target.dataset.product_type; // product_type
                                let destination_id = e.target.dataset.destination_id; // destination_id
                                let destination_code = e.target.dataset.destination_code; // destination_code
                                let text_destination = e.target.dataset.text_destination; // text_destination
                                let category_id = e.target.dataset.category_id; // category_id
                                let category_code = e.target.dataset.category_code; // category_code
                                let modalities_name = e.target.dataset.modalities_name; // modalities_name
                                let modalities_code = e.target.dataset.modalities_code; // modalities_code
                                let dealer_code = e.target.dataset.dealer_code; // dealer_code
                                let dealer_name = e.target.dataset.dealer_name; // dealer_name
                                let dealer_id = e.target.dataset.dealer_id; // dealer_id
                                let calc_amount = e.target.dataset.calc_amount; // calc_amount
                                let adult = e.target.dataset.adult; // adult
                                let children = e.target.dataset.children; // children
                                let pax = e.target.dataset.pax; // pax
                                let min_length_reservation = e.target.dataset.min_length_reservation; // min_length_reservation
                                let max_length_reservation = e.target.dataset.max_length_reservation; // max_length_reservation

                                create_array_for_product('id', product_id); // product_id
                                create_array_for_product('product_type', product_type); // product_type
                                create_array_for_product('destination_id', destination_id); // destination_id
                                create_array_for_product('destination_code', destination_code); // destination_code
                                create_array_for_product('text_destination', text_destination); // text_destination
                                create_array_for_product('category_id', category_id); // category_id
                                create_array_for_product('category_code', category_code); // category_code
                                create_array_for_product('modalities_name', modalities_name); // modalities_name
                                create_array_for_product('modality_code', modalities_code); // modalities_code
                                create_array_for_product('dealer_code', dealer_code); // dealer_code
                                create_array_for_product('dealer_name', dealer_name); // dealer_name
                                create_array_for_product('dealer_id', dealer_id); // dealer_id
                                create_array_for_product('calc_amount', calc_amount); // calc_amount
                                create_array_for_product('adult', adult); // adult
                                create_array_for_product('children', children); // children
                                create_array_for_product('pax', pax); // pax
                                create_array_for_product('amount', '1'); // pax
                                create_array_for_product('min_length_reservation', min_length_reservation); // min_length_reservation
                                create_array_for_product('max_length_reservation', max_length_reservation); // max_length_reservation
                                // console.info(location.origin);

                                create_shopping_cart('static-page-group', product_type).then(shopc => {
                                    if (shopc.next) {
                                        /*if (e.target.dataset.addtocart === 'true') {*/
                                        add_direct_product_to_cart('static-page-group', dealer_code, category_id, '1', product_type, modalities_code).then(
                                            product_add => {
                                                if (product_add.next) {
                                                    location.href = `${location.origin}/${sessionStorage.getItem('locale')}/shopping_cart`
                                                } else {
                                                    toastr.error('No se pudo añadir el producto', 'Carrito de compra')
                                                }
                                            }
                                        )
                                        /*} else {
                                            setTimeout(function () {
                                                toastr.error('No se ha podido agregar el producto al carrito', 'Error');
                                                unBlockElementById('static-page-group');
                                            }, 1000);
                                        }*/
                                    } else {
                                        // setTimeout(function () {
                                        toastr.info('Se creó el No se ha podido agregar el producto al carrito', 'Carrito de compra');
                                        unBlockElementById('static-page-group');
                                        // }, 1000);
                                    }
                                })

                                // Validación exitosa: cerrar el cuadro de diálogo
                                bootbox.hideAll();
                            }
                        }).catch(error => {
                            console.error("Error durante la validación:", error);
                            toastr.error('Ocurrió un error durante la validación.', 'Error');
                        });
                    });
                }
            })
        } else if (page_e.target.dataset.product_tipo === 'buggy') {
            bootbox.dialog({
                title: 'Campos requeridos',
                message: `<div id="campos_reserva" class="col-12 row" data-controller="preferences datime page" data-product_tipo="${page_e.target.dataset.product_tipo}" data-modality_id="${page_e.target.dataset.modalities_id}" data-reservation_time="${page_e.target.dataset.reservation_time}" style="padding: 0; margin: 0;">
                        <div class="form-group col-12">
                            <label for="buggy_date_page">${I18n.t('reservation.side_bar.date')}</label>
                            <input id="buggy_date_page" placeholder="Seleccione una fecha" type="text" class="form-control required">
                            <span class="helper-text small"></span>
                        </div>
                      </div>`,
                size: 'small',
                buttons: {
                    cancel: {
                        label: "Cancelar",
                        className: 'btn-secondary'
                    },
                    ok: {
                        label: "Reservar",
                        className: 'btn-danger',
                        callback: function (e) {
                            /*let check = $('#terms_and_condition_accepted');
                            if (check.is(':checked')) {
                                resolve({
                                    success: true
                                })
                            } else {
                                toastr.warning('Debe acceptar nuestros terminos y condiciones para continuar', 'Términos y condiciones');
                                return true;
                            }*/
                            /*validate('campos_reserva').then(r => {
                                console.info(r);
                                console.info(page_e.target.dataset.product_id); // product_id
                            })*/
                            // Llamada a la función validate

                            // Desactivar el cierre automático del cuadro de diálogo
                            return false;
                        }
                    }
                },
                onShown: function () {
                    // Agregar un evento personalizado al botón "Aceptar"
                    $('.bootbox-accept').on('click', function () {
                        validate('campos_reserva').then(r => {
                            if (r.next === false) {
                                // Validación fallida: mostrar advertencia y mantener el cuadro de diálogo abierto
                                toastr.warning('Por favor, complete los campos requeridos para continuar.', 'Campos requeridos');
                            } else {
                                let product_id = e.target.dataset.product_id; // product_id
                                let product_type = e.target.dataset.product_type; // product_type
                                let destination_id = e.target.dataset.destination_id; // destination_id
                                let destination_code = e.target.dataset.destination_code; // destination_code
                                let text_destination = e.target.dataset.text_destination; // text_destination
                                let category_id = e.target.dataset.category_id; // category_id
                                let category_code = e.target.dataset.category_code; // category_code
                                let modalities_name = e.target.dataset.modalities_name; // modalities_name
                                let modalities_code = e.target.dataset.modalities_code; // modalities_code
                                let dealer_code = e.target.dataset.dealer_code; // dealer_code
                                let dealer_name = e.target.dataset.dealer_name; // dealer_name
                                let dealer_id = e.target.dataset.dealer_id; // dealer_id
                                let calc_amount = e.target.dataset.calc_amount; // calc_amount
                                let adult = e.target.dataset.adult; // adult
                                let children = e.target.dataset.children; // children
                                let pax = e.target.dataset.pax; // pax
                                let min_length_reservation = e.target.dataset.min_length_reservation; // min_length_reservation
                                let max_length_reservation = e.target.dataset.max_length_reservation; // max_length_reservation

                                create_array_for_product('id', product_id); // product_id
                                create_array_for_product('product_type', product_type); // product_type
                                create_array_for_product('destination_id', destination_id); // destination_id
                                create_array_for_product('destination_code', destination_code); // destination_code
                                create_array_for_product('text_destination', text_destination); // text_destination
                                create_array_for_product('category_id', category_id); // category_id
                                create_array_for_product('category_code', category_code); // category_code
                                create_array_for_product('modalities_name', modalities_name); // modalities_name
                                create_array_for_product('modality_code', modalities_code); // modalities_code
                                create_array_for_product('dealer_code', dealer_code); // dealer_code
                                create_array_for_product('dealer_name', dealer_name); // dealer_name
                                create_array_for_product('dealer_id', dealer_id); // dealer_id
                                create_array_for_product('calc_amount', calc_amount); // calc_amount
                                create_array_for_product('adult', adult); // adult
                                create_array_for_product('children', children); // children
                                create_array_for_product('pax', pax); // pax
                                create_array_for_product('amount', '1'); // pax
                                create_array_for_product('min_length_reservation', min_length_reservation); // min_length_reservation
                                create_array_for_product('max_length_reservation', max_length_reservation); // max_length_reservation
                                // console.info(location.origin);

                                create_shopping_cart('static-page-group', product_type).then(shopc => {
                                    if (shopc.next) {
                                        /*if (e.target.dataset.addtocart === 'true') {*/
                                        add_direct_product_to_cart('static-page-group', dealer_code, category_id, '1', product_type, modalities_code).then(
                                            product_add => {
                                                if (product_add.next) {
                                                    location.href = `${location.origin}/${sessionStorage.getItem('locale')}/shopping_cart`
                                                } else {
                                                    toastr.error('No se pudo añadir el producto', 'Carrito de compra')
                                                }
                                            }
                                        )
                                        /*} else {
                                            setTimeout(function () {
                                                toastr.error('No se ha podido agregar el producto al carrito', 'Error');
                                                unBlockElementById('static-page-group');
                                            }, 1000);
                                        }*/
                                    } else {
                                        // setTimeout(function () {
                                        toastr.info('Se creó el No se ha podido agregar el producto al carrito', 'Carrito de compra');
                                        unBlockElementById('static-page-group');
                                        // }, 1000);
                                    }
                                })

                                // Validación exitosa: cerrar el cuadro de diálogo
                                bootbox.hideAll();
                            }
                        }).catch(error => {
                            console.error("Error durante la validación:", error);
                            toastr.error('Ocurrió un error durante la validación.', 'Error');
                        });
                    });
                }
            })
        } else if (page_e.target.dataset.product_tipo === 'accessible_tourism') {
            if (page_e.target.dataset.has_pick_up_locations === "true") {
                bootbox.dialog({
                    id: 'campos_accessible_tourism',
                    title: 'Campos requeridos',
                    message: `<div id="campos_reserva" class="col-12 row" data-controller="preferences datime page" data-product_tipo="${page_e.target.dataset.product_tipo}" data-modality_id="${page_e.target.dataset.modalities_id}" data-reservation_time="${page_e.target.dataset.reservation_time}">
                        <div class="form-group col-12 col-sm-6 col-md-4">
                            <label for="accessible_tourism_pick_up_location_page">${I18n.t('reservation.side_bar.pick_up_location')}</label>
                            <button id="accessible_tpul_btn" class="btn btn-sm btn-info ocultar" style="position: absolute; top: -0.5em; right: 1rem;"><i class="fa fa-map-marker" aria-hidden="true"></i> Mapa</button>
                            <select id="accessible_tourism_pick_up_location_page" class="form-control required"></select>
                            <span class="helper-text small"></span>
                        </div>
                        <div class="form-group col-12 col-sm-6 col-md-4">
                            <!-- <label for="accessible_tourism_date" data-preferences-target="dateCollect"></label>-->
                            <label for="accessible_tourism_date_page">${I18n.t('reservation.side_bar.date')}</label>
                            <input id="accessible_tourism_date_page" placeholder="Seleccione una fecha" type="text" class="form-control required">
                            <span class="helper-text small"></span>
                        </div>
                        <div class="form-group col-12 col-sm-6 col-md-4">
                            <label for="accessible_tourism_cantidad_page">${I18n.t('reservation.side_bar.person_amount')}</label>
                            <input type="number" id="accessible_tourism_cantidad_page" class="form-control required" data-action="change->preferences#evaluate blur->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="${page_e.target.dataset.min_reserv_amount}" data-max="${page_e.target.dataset.max_reserv_amount}">
                            <span class="helper-text small"></span>
                        </div>
                        <div class="form-group col-12">
                            <label for="accessible_tourism_observaciones_page">${I18n.t('histories.check_reservation.comment')}</label>
                            <textarea id="accessible_tourism_observaciones_page" class="form-control" name="comments" placeholder="Escriba sus observaciones aquí..." data-action="preferences#make_comment" data-text="Observaciones: " data-pickup="accessible_tourism_pick_up_location_page"></textarea>
                            <span class="helper-text small"></span>
                        </div>
                    </div>`,
                    size: 'extra-large',
                    buttons: {
                        cancel: {
                            label: "Cancelar",
                            className: 'btn-secondary'
                        },
                        ok: {
                            label: "Reservar",
                            className: 'btn-danger',
                            callback: function (e) {
                                /*let check = $('#terms_and_condition_accepted');
                                if (check.is(':checked')) {
                                    resolve({
                                        success: true
                                    })
                                } else {
                                    toastr.warning('Debe acceptar nuestros terminos y condiciones para continuar', 'Términos y condiciones');
                                    return true;
                                }*/
                                /*validate('campos_reserva').then(r => {
                                    console.info(r);
                                    console.info(page_e.target.dataset.product_id); // product_id
                                })*/
                                // Llamada a la función validate

                                // Desactivar el cierre automático del cuadro de diálogo
                                return false;
                            }
                        }
                    },
                    onShown: function () {
                        // Agregar un evento personalizado al botón "Aceptar"
                        $('.bootbox-accept').on('click', function () {
                            validate('campos_reserva').then(r => {
                                if (r.next === false) {
                                    // Validación fallida: mostrar advertencia y mantener el cuadro de diálogo abierto
                                    toastr.warning('Por favor, complete los campos requeridos para continuar.', 'Campos requeridos');
                                } else {
                                    let product_id = e.target.dataset.product_id; // product_id
                                    let product_type = e.target.dataset.product_type; // product_type
                                    let destination_id = e.target.dataset.destination_id; // destination_id
                                    let destination_code = e.target.dataset.destination_code; // destination_code
                                    let text_destination = e.target.dataset.text_destination; // text_destination
                                    let category_id = e.target.dataset.category_id; // category_id
                                    let category_code = e.target.dataset.category_code; // category_code
                                    let modalities_name = e.target.dataset.modalities_name; // modalities_name
                                    let modalities_code = e.target.dataset.modalities_code; // modalities_code
                                    let dealer_code = e.target.dataset.dealer_code; // dealer_code
                                    let dealer_name = e.target.dataset.dealer_name; // dealer_name
                                    let dealer_id = e.target.dataset.dealer_id; // dealer_id
                                    let calc_amount = e.target.dataset.calc_amount; // calc_amount
                                    /*let adult = e.target.dataset.adult; // adult
                                    let children = e.target.dataset.children; // children
                                    let pax = e.target.dataset.pax; // pax
                                    let min_length_reservation = e.target.dataset.min_length_reservation; // min_length_reservation
                                    let max_length_reservation = e.target.dataset.max_length_reservation; // max_length_reservation*/

                                    create_array_for_product('id', product_id); // product_id
                                    create_array_for_product('product_type', product_type); // product_type
                                    create_array_for_product('destination_id', destination_id); // destination_id
                                    create_array_for_product('destination_code', destination_code); // destination_code
                                    create_array_for_product('text_destination', text_destination); // text_destination
                                    create_array_for_product('category_id', category_id); // category_id
                                    create_array_for_product('category_code', category_code); // category_code
                                    create_array_for_product('modalities_name', modalities_name); // modalities_name
                                    create_array_for_product('modality_code', modalities_code); // modalities_code
                                    create_array_for_product('dealer_code', dealer_code); // dealer_code
                                    create_array_for_product('dealer_name', dealer_name); // dealer_name
                                    create_array_for_product('dealer_id', dealer_id); // dealer_id
                                    create_array_for_product('calc_amount', calc_amount); // calc_amount
                                    /*create_array_for_product('adult', adult); // adult
                                    create_array_for_product('children', children); // children
                                    create_array_for_product('pax', pax); // pax
                                    create_array_for_product('amount', '1'); // pax
                                    create_array_for_product('min_length_reservation', min_length_reservation); // min_length_reservation
                                    create_array_for_product('max_length_reservation', max_length_reservation); // max_length_reservation*/
                                    // console.info(location.origin);

                                    create_shopping_cart('page_body_types_products', product_type).then(shopc => {
                                        if (shopc.next) {
                                            /*if (e.target.dataset.addtocart === 'true') {*/
                                            add_direct_product_to_cart('page_body_types_products', dealer_code, category_id, create_array_for_product('amount', '', 'show'), product_type, modalities_code).then(
                                                product_add => {
                                                    if (product_add.next) {
                                                        location.href = `${location.origin}/${sessionStorage.getItem('locale')}/shopping_cart`
                                                    } else {
                                                        toastr.error('No se pudo añadir el producto', 'Carrito de compra')
                                                    }
                                                }
                                            )
                                            /*} else {
                                                setTimeout(function () {
                                                    toastr.error('No se ha podido agregar el producto al carrito', 'Error');
                                                    unBlockElementById('page_body_types_products');
                                                }, 1000);
                                            }*/
                                        } else {
                                            // setTimeout(function () {
                                            toastr.info('Se creó el No se ha podido agregar el producto al carrito', 'Carrito de compra');
                                            unBlockElementById('page_body_types_products');
                                            // }, 1000);
                                        }
                                    })

                                    // Validación exitosa: cerrar el cuadro de diálogo
                                    bootbox.hideAll();
                                }
                            }).catch(error => {
                                console.error("Error durante la validación:", error);
                                toastr.error('Ocurrió un error durante la validación.', 'Error');
                            });
                        });
                    }
                })
            } else {
                bootbox.alert({
                    title: '<span class="text-info"><i class="fa fa-info"></i> Información</i></span>',
                    message: '<div class="p-0 m-0 text-center">Producto disponible próximamente</div>',
                    /*className: 'alert-info',
                    backdrop: true,*/
                    size: 'medium',
                    buttons: {
                        ok: {
                            label: "",
                            className: 'ocultar',
                        }
                    }
                });
            }
        } else if (page_e.target.dataset.product_tipo === 'transfers') {
            if (page_e.target.dataset.has_pick_up_locations === "true" && page_e.target.dataset.has_drop_off_locations === "true") {
                bootbox.dialog({
                    id: 'campos_transfers',
                    title: 'Campos requeridos',
                    message: `<div id="campos_reserva" class="col-12 row" data-controller="preferences datime page" data-product_tipo="${page_e.target.dataset.product_tipo}" data-modality_id="${page_e.target.dataset.modalities_id}" data-reservation_time="${page_e.target.dataset.reservation_time}" data-has_pick_up_locations="${page_e.target.dataset.has_pick_up_locations}" data-has_drop_off_locations="${page_e.target.dataset.has_drop_off_locations}" style="padding: 0; margin: 0;">
                        <div class="form-group col-12 col-sm-6">
                            <label for="transfers_cantidad_page"> ${I18n.t('reservation.side_bar.amount')} </label>
                            <input id="transfers_cantidad_page" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="${page_e.target.dataset.min_reserv_amount}" data-max="${page_e.target.dataset.max_reserv_amount}">
                            <span class="helper-text small"></span>
                        </div>                             
                        <div class="form-group col-12 col-sm-6">
                            <label for="transfers_pick_up_location_page">${I18n.t('reservation.side_bar.pick_up_location')}</label>
                            <button id="transfers_pul_btn_page" class="btn btn-sm btn-info ocultar" style="position: absolute; top: -0.5em; right: 1rem;"><i class="fa fa-map-marker" aria-hidden="true"></i> Mapa</button>
                            <select id="transfers_pick_up_location_page" class="form-control required"></select>
                            <span class="helper-text small"></span>
                        </div>                             
                        <div class="form-group col-12 col-sm-6">
                            <label for="transfers_drop_off_location_page">${I18n.t('reservation.side_bar.drop_off_location')}</label>
                            <button id="transfers_dol_btn_page" class="btn btn-sm btn-info ocultar" style="position: absolute; top: -0.5em; right: 1rem;"><i class="fa fa-map-marker" aria-hidden="true"></i> Mapa</button>
                            <select id="transfers_drop_off_location_page" class="form-control required"></select>
                            <span class="helper-text small"></span>
                        </div>
                        <div class="form-group col-12 col-sm-6">
                            <label for="transfers_date_page">${I18n.t('reservation.side_bar.date')}</label>
                            <input id="transfers_date_page" placeholder="Seleccione una fecha" type="text" class="form-control required">
                            <span class="helper-text small"></span>
                        </div>
                        <div class="form-group col-12">
                            <label for="transfers_observaciones_page">${I18n.t('histories.check_reservation.comment')}</label>
                            <textarea id="transfers_observaciones_page" class="form-control" name="comments" placeholder="Escriba sus observaciones aquí..." data-action="preferences#make_comment" data-text="Observaciones: " data-pickup="transfers_pick_up_location_page" data-dropoff="transfers_drop_off_location_page"></textarea>
                            <span class="helper-text small text-muted">${I18n.t('reservation.side_bar.pickup_place_description')}</span>
                        </div>
                    </div>`,
                    size: 'large',
                    buttons: {
                        cancel: {
                            label: "Cancelar",
                            className: 'btn-secondary'
                        },
                        ok: {
                            label: "Reservar",
                            className: 'btn-danger',
                            callback: function (e) {
                                /*let check = $('#terms_and_condition_accepted');
                                if (check.is(':checked')) {
                                    resolve({
                                        success: true
                                    })
                                } else {
                                    toastr.warning('Debe acceptar nuestros terminos y condiciones para continuar', 'Términos y condiciones');
                                    return true;
                                }*/
                                /*validate('campos_reserva').then(r => {
                                    console.info(r);
                                    console.info(page_e.target.dataset.product_id); // product_id
                                })*/
                                // Llamada a la función validate

                                // Desactivar el cierre automático del cuadro de diálogo
                                return false;
                            }
                        }
                    },
                    onShown: function () {
                        // Agregar un evento personalizado al botón "Aceptar"
                        $('.bootbox-accept').on('click', function () {
                            validate('campos_reserva').then(r => {
                                if (r.next === false) {
                                    // Validación fallida: mostrar advertencia y mantener el cuadro de diálogo abierto
                                    toastr.warning('Por favor, complete los campos requeridos para continuar.', 'Campos requeridos');
                                } else {
                                    let product_id = e.target.dataset.product_id; // product_id
                                    let product_type = e.target.dataset.product_type; // product_type
                                    let destination_id = e.target.dataset.destination_id; // destination_id
                                    let destination_code = e.target.dataset.destination_code; // destination_code
                                    let text_destination = e.target.dataset.text_destination; // text_destination
                                    let category_id = e.target.dataset.category_id; // category_id
                                    let category_code = e.target.dataset.category_code; // category_code
                                    let modalities_name = e.target.dataset.modalities_name; // modalities_name
                                    let modalities_code = e.target.dataset.modalities_code; // modalities_code
                                    let dealer_code = e.target.dataset.dealer_code; // dealer_code
                                    let dealer_name = e.target.dataset.dealer_name; // dealer_name
                                    let dealer_id = e.target.dataset.dealer_id; // dealer_id
                                    let calc_amount = e.target.dataset.calc_amount; // calc_amount
                                    /*let adult = e.target.dataset.adult; // adult
                                    let children = e.target.dataset.children; // children
                                    let pax = e.target.dataset.pax; // pax
                                    let min_length_reservation = e.target.dataset.min_length_reservation; // min_length_reservation
                                    let max_length_reservation = e.target.dataset.max_length_reservation; // max_length_reservation*/

                                    create_array_for_product('id', product_id); // product_id
                                    create_array_for_product('product_type', product_type); // product_type
                                    create_array_for_product('destination_id', destination_id); // destination_id
                                    create_array_for_product('destination_code', destination_code); // destination_code
                                    create_array_for_product('text_destination', text_destination); // text_destination
                                    create_array_for_product('category_id', category_id); // category_id
                                    create_array_for_product('category_code', category_code); // category_code
                                    create_array_for_product('modalities_name', modalities_name); // modalities_name
                                    create_array_for_product('modality_code', modalities_code); // modalities_code
                                    create_array_for_product('dealer_code', dealer_code); // dealer_code
                                    create_array_for_product('dealer_name', dealer_name); // dealer_name
                                    create_array_for_product('dealer_id', dealer_id); // dealer_id
                                    create_array_for_product('calc_amount', calc_amount); // calc_amount
                                    /*create_array_for_product('adult', adult); // adult
                                    create_array_for_product('children', children); // children
                                    create_array_for_product('pax', pax); // pax
                                    create_array_for_product('amount', '1'); // pax
                                    create_array_for_product('min_length_reservation', min_length_reservation); // min_length_reservation
                                    create_array_for_product('max_length_reservation', max_length_reservation); // max_length_reservation*/
                                    // console.info(location.origin);

                                    create_shopping_cart('page_body_types_products', product_type).then(shopc => {
                                        if (shopc.next) {
                                            /*if (e.target.dataset.addtocart === 'true') {*/
                                            add_direct_product_to_cart('page_body_types_products', dealer_code, category_id, create_array_for_product('amount', '', 'show'), product_type, modalities_code).then(
                                                product_add => {
                                                    if (product_add.next) {
                                                        location.href = `${location.origin}/${sessionStorage.getItem('locale')}/shopping_cart`
                                                    } else {
                                                        toastr.error('No se pudo añadir el producto', 'Carrito de compra')
                                                    }
                                                }
                                            )
                                            /*} else {
                                                setTimeout(function () {
                                                    toastr.error('No se ha podido agregar el producto al carrito', 'Error');
                                                    unBlockElementById('page_body_types_products');
                                                }, 1000);
                                            }*/
                                        } else {
                                            // setTimeout(function () {
                                            toastr.info('Se creó el No se ha podido agregar el producto al carrito', 'Carrito de compra');
                                            unBlockElementById('page_body_types_products');
                                            // }, 1000);
                                        }
                                    })

                                    // Validación exitosa: cerrar el cuadro de diálogo
                                    bootbox.hideAll();
                                }
                            }).catch(error => {
                                console.error("Error durante la validación:", error);
                                toastr.error('Ocurrió un error durante la validación.', 'Error');
                            });
                        });
                    }
                })
            } else {
                bootbox.alert({
                    title: '<span class="text-info"><i class="fa fa-info"></i> Información</i></span>',
                    message: '<div class="p-0 m-0 text-center">Producto disponible próximamente</div>',
                    /*className: 'alert-info',
                    backdrop: true,*/
                    size: 'medium',
                    buttons: {
                        ok: {
                            label: "",
                            className: 'ocultar',
                        }
                    }
                });
            }
        } else if (page_e.target.dataset.product_tipo === 'bicicleta') {
            bootbox.dialog({
                title: 'Campos requeridos',
                message: `<div id="campos_reserva" class="col-12 row" data-controller="preferences datime page" data-product_tipo="${page_e.target.dataset.product_tipo}" data-modality_id="${page_e.target.dataset.modalities_id}" data-reservation_time="${page_e.target.dataset.reservation_time}" style="padding: 0; margin: 0;">
                        <div class="form-group col-12">
                            <label for="bicicleta_cantidad"> ${I18n.t('reservation.side_bar.amount')} </label>
                            <input id="bicicleta_cantidad" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="${page_e.target.dataset.min_reserv_amount}" data-max="${page_e.target.dataset.max_reserv_amount}">
                            <span class="helper-text small"></span>
                        </div>
                        <div class="form-group col-12">
                            <label for="bicicleta_date">${I18n.t('reservation.side_bar.date')}</label>
                            <input id="bicicleta_date" placeholder="Seleccione una fecha" type="text" class="form-control required">
                            <span class="helper-text small"></span>
                        </div>
                    </div>`,
                size: 'small',
                buttons: {
                    cancel: {
                        label: "Cancelar",
                        className: 'btn-secondary'
                    },
                    ok: {
                        label: "Reservar",
                        className: 'btn-danger',
                        callback: function (e) {
                            /*let check = $('#terms_and_condition_accepted');
                            if (check.is(':checked')) {
                                resolve({
                                    success: true
                                })
                            } else {
                                toastr.warning('Debe acceptar nuestros terminos y condiciones para continuar', 'Términos y condiciones');
                                return true;
                            }*/
                            /*validate('campos_reserva').then(r => {
                                console.info(r);
                                console.info(page_e.target.dataset.product_id); // product_id
                            })*/
                            // Llamada a la función validate

                            // Desactivar el cierre automático del cuadro de diálogo
                            return false;
                        }
                    }
                },
                onShown: function () {
                    // Agregar un evento personalizado al botón "Aceptar"
                    $('.bootbox-accept').on('click', function () {
                        validate('campos_reserva').then(r => {
                            if (r.next === false) {
                                // Validación fallida: mostrar advertencia y mantener el cuadro de diálogo abierto
                                toastr.warning('Por favor, complete los campos requeridos para continuar.', 'Campos requeridos');
                            } else {
                                let product_id = e.target.dataset.product_id; // product_id
                                let product_type = e.target.dataset.product_type; // product_type
                                let destination_id = e.target.dataset.destination_id; // destination_id
                                let destination_code = e.target.dataset.destination_code; // destination_code
                                let text_destination = e.target.dataset.text_destination; // text_destination
                                let category_id = e.target.dataset.category_id; // category_id
                                let category_code = e.target.dataset.category_code; // category_code
                                let modalities_name = e.target.dataset.modalities_name; // modalities_name
                                let modalities_code = e.target.dataset.modalities_code; // modalities_code
                                let dealer_code = e.target.dataset.dealer_code; // dealer_code
                                let dealer_name = e.target.dataset.dealer_name; // dealer_name
                                let dealer_id = e.target.dataset.dealer_id; // dealer_id
                                let calc_amount = e.target.dataset.calc_amount; // calc_amount
                                /*let adult = e.target.dataset.adult; // adult
                                let children = e.target.dataset.children; // children
                                let pax = e.target.dataset.pax; // pax
                                let min_length_reservation = e.target.dataset.min_length_reservation; // min_length_reservation
                                let max_length_reservation = e.target.dataset.max_length_reservation; // max_length_reservation*/

                                create_array_for_product('id', product_id); // product_id
                                create_array_for_product('product_type', product_type); // product_type
                                create_array_for_product('destination_id', destination_id); // destination_id
                                create_array_for_product('destination_code', destination_code); // destination_code
                                create_array_for_product('text_destination', text_destination); // text_destination
                                create_array_for_product('category_id', category_id); // category_id
                                create_array_for_product('category_code', category_code); // category_code
                                create_array_for_product('modalities_name', modalities_name); // modalities_name
                                create_array_for_product('modality_code', modalities_code); // modalities_code
                                create_array_for_product('dealer_code', dealer_code); // dealer_code
                                create_array_for_product('dealer_name', dealer_name); // dealer_name
                                create_array_for_product('dealer_id', dealer_id); // dealer_id
                                create_array_for_product('calc_amount', calc_amount); // calc_amount
                                /*create_array_for_product('adult', adult); // adult
                                create_array_for_product('children', children); // children
                                create_array_for_product('pax', pax); // pax
                                create_array_for_product('amount', '1'); // pax
                                create_array_for_product('min_length_reservation', min_length_reservation); // min_length_reservation
                                create_array_for_product('max_length_reservation', max_length_reservation); // max_length_reservation*/
                                // console.info(location.origin);

                                create_shopping_cart('page_body_types_products', product_type).then(shopc => {
                                    if (shopc.next) {
                                        /*if (e.target.dataset.addtocart === 'true') {*/
                                        add_direct_product_to_cart('page_body_types_products', dealer_code, category_id, create_array_for_product('amount', '', 'show'), product_type, modalities_code).then(
                                            product_add => {
                                                if (product_add.next) {
                                                    location.href = `${location.origin}/${sessionStorage.getItem('locale')}/shopping_cart`
                                                } else {
                                                    toastr.error('No se pudo añadir el producto', 'Carrito de compra')
                                                }
                                            }
                                        )
                                        /*} else {
                                            setTimeout(function () {
                                                toastr.error('No se ha podido agregar el producto al carrito', 'Error');
                                                unBlockElementById('page_body_types_products');
                                            }, 1000);
                                        }*/
                                    } else {
                                        // setTimeout(function () {
                                        toastr.info('Se creó el No se ha podido agregar el producto al carrito', 'Carrito de compra');
                                        unBlockElementById('page_body_types_products');
                                        // }, 1000);
                                    }
                                })

                                // Validación exitosa: cerrar el cuadro de diálogo
                                bootbox.hideAll();
                            }
                        }).catch(error => {
                            console.error("Error durante la validación:", error);
                            toastr.error('Ocurrió un error durante la validación.', 'Error');
                        });
                    });
                }
            })
        } else if (page_e.target.dataset.product_tipo === 'bike') {
            bootbox.alert(`<h5 style="text-align: center;">En breve estará disponible</h5>`);
        } else {

        }
    }
}